import store from '@common/store/store';
import * as commonActionType from '@common/store/common/common.actionsType';
import PubSub from 'pubsub-js';

export default function execute(nextRoute) {
  //Dispara o RESET para limpar a Store
  store.dispatch({
    type: commonActionType.RESET,
  });

  PubSub.publish(commonActionType.CLOSE_MENU);

  //Remover Listern
  PubSub.unsubscribe(commonActionType.RESET);
  PubSub.unsubscribe(commonActionType.GRID_RELOAD);
  PubSub.unsubscribe(commonActionType.TREEVIEW_RELOAD);

  return nextRoute;
}
